export const DEFAULT_POINT = [55.75, 37.62];

export const reducePrecision = (v: number) => Number(`${Math.round(v * 10000)}e-4`);

export type TestGeoProps = {
    onCancel(): void;
    onSubmit(_point: { lat: number; lon: number }): void;
};
